module.exports = __webpack_public_path__ + "static/media/crypto.514452db.svg";